'use client';

import React from 'react';
import { throttle } from 'lodash-es';
import EntryCard from '@/components/EntryList/EntryCard';
import useSendAnalytics from '@/hooks/useSendAnalytics';
import { ListEntry } from '@/types/ListEntry';
import { PictureFormats } from '@/components/Image/Picture';

export interface EntryCardWithRecommendationAnalyticsProps {
  entryId: number;
  entry: ListEntry;
  analyticsName: string;
  index: number;
  pictureFormats: PictureFormats;
}

export function EntryCardWithRecommendationAnalytics({
  entryId,
  entry,
  analyticsName,
  index,
  pictureFormats,
}: EntryCardWithRecommendationAnalyticsProps) {
  const sendAnalytics = useSendAnalytics();

  const handleAnalytics = throttle((entry: ListEntry, analyticsName: string) => {
    sendAnalytics(analyticsName, {
      entryId: entry.id,
      sourceEntryId: entryId,
    });
  }, 1000);

  return (
    <EntryCard
      key={entry.id}
      entry={entry}
      variant="scroller"
      analytics={{
        listId: analyticsName === 'peer_entry_click' ? 'auction_others_also_viewed' : 'auction_might_also_like',
        listName: analyticsName === 'peer_entry_click' ? 'Others also viewed' : 'Might also like',
        sourceEntryId: entryId,
        index,
      }}
      onClick={() => handleAnalytics(entry, analyticsName)}
      pictureFormats={pictureFormats}
    />
  );
}
